import classNames from 'classnames'
import { useState } from 'react'

import { type ICommonField } from '@/app/types/common'
import { EIcons } from '@/app/types/iconType'
import { type TextAreaEvent } from '@/pages/Dms/helper'
import { Icon, TextArea } from '@/shared'

import style from './TextAreaField.module.scss'

interface IProps {
    entity: ICommonField
    onChange: (e: TextAreaEvent) => void
    className?: string
    onSetIsTouched: () => void
    disabled?: boolean
    withMarkdown?: boolean
}

export const TextAreaField = (props: IProps) => {
    const { entity, className, disabled, withMarkdown = false, onChange, onSetIsTouched } = props
    const { name, value, error, isTouched, placeholder } = entity
    const [showPrograms, setShowPrograms] = useState<boolean>(false)
    const isError = isTouched && !!error
    return (
        <div className={classNames(style.container, className && className)}>
            <div className={style.blockTitle}>
                <span>{name}</span>
            </div>
            <div className={style.inputWrapper}>
                {!showPrograms && (
                    <div
                        onClick={() => setShowPrograms((prev) => !prev)}
                        className={classNames(
                            style.shortText,
                            isError && style.shortTextError,
                            disabled && style.shortTextDisabled
                        )}
                    >
                        <span>{'Раскройте для просмотра программы'}</span>
                    </div>
                )}
                {showPrograms && (
                    <TextArea
                        withMarkdown={withMarkdown}
                        className={style.field}
                        value={value || ''}
                        onChange={onChange}
                        onTouch={onSetIsTouched}
                        placeholder={placeholder}
                        disabled={disabled}
                        isError={isError}
                    />
                )}
                <div
                    className={classNames(style.check, showPrograms && style.checkOpened)}
                    onClick={() => setShowPrograms((prev) => !prev)}
                >
                    <Icon iconName={EIcons.AROW} />
                </div>
            </div>
        </div>
    )
}
